import { brandStorage as localStorage } from '@/utils/brandSession';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('hw_token')}` });

export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
};

// Registra (o riusa) la sottoscrizione push e la salva sul backend.
// Il backend accetta SOLO ruoli ufficio: per gli altri utenti fallisce con 403 in silenzio.
export async function ensurePushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  if (!('Notification' in window) || Notification.permission !== 'granted') return false;
  const reg = await navigator.serviceWorker.ready;
  const r = await axios.get(`${API}/cs-control/push/vapid-key`, { headers: authHeaders() });
  if (!r.data?.key) return false;
  const wanted = urlBase64ToUint8Array(r.data.key);
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    const cur = sub.options?.applicationServerKey ? new Uint8Array(sub.options.applicationServerKey) : null;
    const same = cur && cur.length === wanted.length && cur.every((v, i) => v === wanted[i]);
    if (!same) {
      await sub.unsubscribe().catch(() => {});
      sub = null;
    }
  }
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: wanted });
  }
  await axios.post(`${API}/cs-control/push/subscribe`,
    { subscription: sub.toJSON(), user_agent: navigator.userAgent },
    { headers: authHeaders() });
  return true;
}

export async function removePushSubscription() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await axios.post(`${API}/cs-control/push/unsubscribe`, { endpoint: sub.endpoint }, { headers: authHeaders() }).catch(() => {});
      await sub.unsubscribe();
    }
  } catch (_) { /* niente da fare */ }
  return true;
}
